import { NVButton } from '@nv/basic-components'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import styles from './BottomBar.module.scss'

export const BottomBar = ({ links }) => {
  const navigate = useNavigate()

  return (
    <div className={styles['container']}>
      {Object.entries(links).map(([tabkey, tabValue]) => {
        const active = window.location.pathname.includes(tabValue.path)

        return (
          <NVButton
            variant='text'
            key={tabkey}
            classes={{ container: clsx(styles['tab'], active && styles['tab-active']) }}
            onClick={() => navigate(tabValue.path)}
            icon={tabValue.icon && <tabValue.icon />}
          />
        )
      })}
    </div>
  )
}
